import { TableHeaderType } from "../types/TableHeaderType";

export const CloudProvisionerHeader: TableHeaderType[] = [
    {
      label: 'ID',
      key: 'id',
      id: 'id',
      sortable: true,
    },
    {
      label:'ProjectID',
      key: 'projectId',
      id: 'projectId',
      sortable: false,
    },
    {
      label:'FileName',
      key: 'fileName',
      id: 'fileName',
      sortable: true,
    },
    {
      id: 'flavor',
      label: 'Flavor',
      sortable: false,
      key: 'flavor',
    },
    {
      id: 'providerType',
      label: 'ProviderType',
      sortable: true,
      key: 'providerType',
    },
  ];